<template>
  <div class="nav-bar">
    <router-link to="/" class="nav-brand">
      <img
        class="nav-brand__logo"
        src="/assets/logo.png"
        width="36"
        height="36"
        alt="云导航"
      />
      <span class="nav-brand__title">云导航</span>
    </router-link>
    <el-menu
      :default-active="activeIndex"
      class="nav-menu"
      mode="horizontal"
      ellipsis
      @select="onSelect"
    >
      <el-menu-item index="/">首页</el-menu-item>
      <el-menu-item index="/extension">插件</el-menu-item>
      <el-sub-menu v-if="auth.isLoggedIn" index="admin">
        <template #title>{{ auth.displayName || "已登录" }}</template>
        <el-menu-item index="/admin/logout">登出</el-menu-item>
      </el-sub-menu>
      <el-menu-item v-else index="/admin/login">登入</el-menu-item>
    </el-menu>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { fetchCurrentUser } from "@/api/user";

const auth = useAuthStore();
const route = useRoute();
const router = useRouter();
const activeIndex = computed(() => route.path);

function onSelect(index: string) {
  if (index === "admin") return;
  if (route.path !== index) {
    void router.push(index);
  }
}

onMounted(async () => {
  auth.clearIfExpired();
  if (!auth.authorization) return;
  if (auth.user.id) return;
  try {
    const response = await fetchCurrentUser();
    if (response.data === null) {
      // 有 token 但拉不到用户 → 视为登录失效
      auth.clearSession();
    } else {
      auth.setUser(response.data);
    }
  } catch {
    // 鉴权失败时拦截器已 clearSession
  }
});
</script>

<style scoped>
.nav-bar {
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 16px;
  box-sizing: border-box;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 12px;
  flex-shrink: 0;
  text-decoration: none;
  color: inherit;
}

.nav-brand__logo {
  display: block;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: contain;
}

.nav-brand__title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2d3d;
  letter-spacing: 0.02em;
}

.nav-menu {
  flex: 1;
  min-width: 0;
  border-bottom: none !important;
}
</style>
